<template>
  <div class="ui segments">

    <div class="ui segment">
      <div class="ui breadcrumb">
       <router-link :to="{name:'home'}" class="section">Sākums</router-link>
        <span class="divider">/</span>
        <router-link :to="{name:'waiting-for-delivery'}" class="section">Gaida piegādi</router-link>
        <span class="divider">/</span>
        <router-link :to="{name:'waiting-for-delivery-edit', params:{id:cart.id}}" class="section">#{{cart.id}}</router-link>
        <span class="divider">/</span>
        <div class="active section">Pievienot preces</div>
      </div>
    </div>

  <div class="ui attached segment">

    <category-menu></category-menu>
	
	<div v-if="storeStatus.loading" class="ui active centered inline loader" style="padding:20px"></div>

    <div v-if="!storeStatus.loading" class="ui stackable three cards">

        <div v-for="item in goods" class="ui fluid card">
          <div @click="$router.push('/good/'+item.link)" style="cursor:pointer">
            <div style="position:absolute; padding:5px; z-index:100">
              <a v-for="badge in item.badges" class="ui label" :style="{ backgroundColor: '#'+badge.color, color: '#210404'}">{{badge.label}}</a>
            </div>
            <img class="ui centered image" v-if="item.images[0]" :src="item.images[0].url" />
            <img class="ui centered image" v-else :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/'+item.id+'.jpg'" />
          </div>
          <div class="content">

            <router-link :to="'/good/'+item.link" style="margin-bottom:5px" class="header">{{item.goods_name}}</router-link>

            <div class="meta">
              <div class="ui tag labels">
                <a class="ui custom_brown label">

                Cena: {{realPrice(item)}} &euro;
              </a>
                <a v-if="item.bail>0" class="ui green label">
                Drošības nauda: {{item.bail}} &euro;
              </a>
              </div>
            </div>
            <div class="description">
              {{item.description}}
            </div>
          </div>

          <button v-if="!checkIfInCart(item)" @click="addItemToCart(item)" class="ui bottom attached button">
            <i class="add icon"></i> Pievienot
          </button>
          <div v-else class="ui three bottom attached  buttons">
           <div class="ui  button" @click="reduceItemInCart(item)">
             <i class="minus icon"></i>
           </div>
           <div class="ui  button" @click="$router.push({name:'waiting-for-delivery-edit', params:{id:cart.id}})">
              <i class="cart icon"></i> {{howManyInCart(item)}} gab.
           </div>
           <div class="ui  button" @click="addItemToCart(item)">
             <i class="add icon"></i>
           </div>
          </div>


        </div>

    </div>



  </div>

  <div class="ui clearing segment">
    <div style="float:right">
<paginator :paginator="paginator" link-name="goods-page"></paginator>
</div>
  </div>
</div>
</template>

<script>

import CategoryMenu from './CategoryMenu'
import Paginator from './Paginator'

export default {
  components: {
    CategoryMenu,
    Paginator
  },

  data () {
    return {
      page:1,
      isactive:false,
      category:'',
      categorya:'',
      categoryb:''
    }
  },

  computed: {
    cart() {
      return this.$store.state.orderStore.details;
    },
    cartItems() {
        return this.$store.state.orderStore.cartitems;
      },
    storeStatus() {
      return this.$store.state.goodStore.status;
    },
    goods() {
      return this.$store.state.goodStore.items
    },
    paginator() {
      return this.$store.state.goodStore.goodsExtraData
    },
    searchTerm() {
      return this.$store.state.categoryStore.searchTerm
    }
 },

 activated: function() {

   //if autoship not definet then go bock to autoship list
   if(!this.cart.id){

     this.$router.push({
       name: 'waiting-for-delivery',
     });
   }

   this.isactive = true; //used to ensure that when route keeps changing we dont reload data while component is not visible
   //preload data

   this.category = '';
   this.categorya = '';
   this.categoryb = '';
   //this.loadActiveCart();
   this.loadGoods();

 },

 deactivated: function() {
   this.isactive = false;
 },

 watch: {
   //'$route.params': 'loadGoods',
   //'searchTerm': 'searchForGoods'
 },

 methods: {
   loadGoods() {
     //as this is called by watcher then first check if component is activated
     var page = (this.$route.params.page) ? this.$route.params.page : 1;
     if (this.isactive) this.$store.dispatch('loadGood', [page, this.searchTerm]);
   },
   searchForGoods(){
     //check if user started to search and he is yes then move to first page so that we can show items
     if(this.$route.params.page>1){
       this.$router.push({
         name: 'goods',
       });
     }
     this.loadGoods();
   },
   checkIfInCart(item){

      if(this.$store.state.orderStore.cartitems.length > 0 && this.$store.state.orderStore.cartitems.filter(function(e) { return e.good_id == item.id }).length > 0) return true;
      else return false;
   },
   howManyInCart(item){
     if(this.checkIfInCart(item)){
       var cartItem = this.$store.state.orderStore.cartitems.filter(function(e) { return e.good_id == item.id });
       return cartItem[0].order;
     }
     else return 0;
   },
   realPrice(item){
     if(this.checkIfInCart(item)){
       var cartItem = this.$store.state.orderStore.cartitems.filter(function(e) { return e.good_id == item.id });

       return cartItem[0].price_vat;
     }
     else return item.base_price_vat;
   },
   gotoCart(){
     this.$router.push({
       name: 'waiting-for-delivery-edit',
       parems:{
         id:this.cart.id
       }
     });
   },
   addItemToCart(item){

     var itemInCart = this.checkIfInCart(item);
     if(itemInCart){
       var cartItem = this.$store.state.orderStore.cartitems.filter(function(e) { return e.good_id == item.id });
       var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
       updatedItem.order ++;
     }
     else{
       var updatedItem = {
         order:1,
         good_id:item.id
       }
     }

     this.$store.dispatch('addOrderItem', [this.cart.id, updatedItem]).then((response) => {
       this.$store.dispatch('loadOrderDetails', this.cart.id);
     }).catch((error) => {

       console.error('Cart was not loaded')
     });

   },

   reduceItemInCart(item){
     var itemInCart = this.checkIfInCart(item);
     if(itemInCart){
       var cartItem = this.$store.state.orderStore.cartitems.filter(function(e) { return e.good_id == item.id });
       var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
       updatedItem.order --;

       this.$store.dispatch('addOrderItem', [this.cart.id, updatedItem]).then((response) => {
         this.$store.dispatch('loadOrderDetails', this.cart.id);
       }).catch((error) => {

         console.error('Cart was not loaded')
       });

     }
   }
}
}
</script>



</style>



// WEBPACK FOOTER //
// WaitingForDeliveryAddGoodsPage.vue?757a5915